<template>
	<div id="StepWizardCommercialName" class="text-left">
		<template>
			<div class="title-area">
				<h4>Nos conte mais...</h4>
			</div>
			<div class="input-area">
				<div class="row">
					<div class="col-12 mb-4">
						<label for="artisticName">Nome</label>
						<input
							id="artisticName"
							type="text"
							class="form-control"
							placeholder="Nome Comercial"
							v-model="artisticName"
							maxlength="25"
							@keyup="checkSugestions"
						/>
					</div>
					<div class="col-12 mb-4">
						<label class="d-block">Cidades que atua</label>
						<span
							class="add--list--button"
							@click="showModal = true"
						></span>
						<span
							v-for="city in listCities"
							class="span--cities"
							:key="city"
							>{{ city }}</span
						>
					</div>
					<div class="col-12 mb-4">
						<label for="urlSuggestion" class="d-block"
							>Domínio provisório</label
						>
						<input
							type="text"
							class="form-control w-50 d-inline-block"
							name="urlSuggestion"
							id="urlSuggestion"
							v-model="userUrl"
							@keyup="checkSugestions"
						/>
						<span>{{ urlComplement }}</span>
						<p v-if="!urlChecked && userUrl.length > 0">
							<small>URL não disponível</small>
						</p>
						<p v-else>
							<small
								>Fique tranquilo, depois você poderá configurar o
								domínio do seu site.</small
							>
						</p>
					</div>
					<b-modal
						centered
						hide-footer
						ref="addCategoryModal"
						v-model="showModal"
						title="Adicionar Cidade"
					>
						<div class="row">
							<div class="col-12">
								<b-form-input
									ref="focusThis"
									id="newCity"
									v-model="newCity"
									type="text"
									class="form-control default_input"
									placeholder="Digite a cidade"
									@keyup.enter="addNewCity"
									maxlength="40"
								/>
							</div>
							<div class="col-12 text-right mt-2">
								<button
									@click="addNewCity()"
									class="btn btn-primario"
								>
									Adicionar
								</button>
							</div>
						</div>
					</b-modal>
				</div>
			</div>
		</template>
		<button class="show--content--button px-3" @click="toggleContent"> <i class="fas fa-eye"></i> </button>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "StepWizardCommercialName",
		data() {
			return {
				artisticName: "",
				userUrl: "",
				urlChecked: false,
				showModal: false,
				listCities: [],
				newCity: "",
				API_CALL_IN_PROGRESS: false,
				showRealContent: false,
                linkWhatsContact: "",
			};
		},
		mounted() {
            let whatsNumber = process.env.WHATS_NUMBER;
            this.linkWhatsContact = `https://api.whatsapp.com/send?phone=${whatsNumber}&text=Oi%2C%20quero%20come%C3%A7ar%20meu%20site%2C%20pode%20me%20ajudar%3F`
			this.$emit("updateStep");
			this.listCities = this.$store.state.wizard.dataSite.cities;
			this.$store.dispatch("WIZARD_SHOW_SKIP", [false]);
			this.submitWizard()
			const contract = this.$store.state.dashboardModule.siteData.contract
			this.showRealContent = (contract && contract.status == 'active')
		},
		methods: {
			addNewCity() {
				if (this.newCity.length > 1) {
					this.$store.dispatch("WIZARD_CITY_ADD", [this.newCity]);
				}
				this.showModal = false;
				this.newCity = "";
			},
			checkSugestions: _.debounce(function (e) {
				if (e.target.id == "urlSuggestion") {
					this.checkUserUrl(this.userUrl, "urlSuggestion");
				} else {
					let checkWord;
					if (e.target.value.length > 0) {
						checkWord = e.target.value.toLowerCase().search("www");
						if (checkWord < 0) {
							checkWord = e.target.value
								.toLowerCase()
								.search(/\.com/);
							if (checkWord < 0) {
								this.checkUserUrl(
									this.artisticName,
									"artisticName"
								);
								this.alertArtisticName = false;
							} else {
								this.alertArtisticName = true;
							}
						} else {
							this.alertArtisticName = true;
						}
					}
				}
			}, 400),
			checkInstantly: function (e) {
				if (e.target.id == "urlSuggestion") {
					this.checkUserUrl(this.userUrl, "urlSuggestion");
				} else {
					let checkWord;
					if (e.target.value.length > 0) {
						checkWord = e.target.value.toLowerCase().search("www");
						if (checkWord < 0) {
							checkWord = e.target.value
								.toLowerCase()
								.search(/\.com/);
							if (checkWord < 0) {
								this.checkUserUrl(
									this.artisticName,
									"artisticName"
								);
								this.alertArtisticName = false;
							} else {
								this.alertArtisticName = true;
							}
						} else {
							this.alertArtisticName = true;
						}
					}
				}
			},
			checkUserUrl(userName, event) {
				if (this.API_CALL_IN_PROGRESS == false) {
					this.API_CALL_IN_PROGRESS = true;
					let totalData = {
							siteName: userName,
							site: this.$store.state.application.app_site,
							input: event,
						},
						token = this.$session.get("jwt"),
						siteId = this.$session.get("siteId");
					axios({
						method: "post",
						url: `${process.env.ROOT_API}/api/site/${siteId}/checkdomain`,
						data: totalData,
						headers: {
							Authorization: "Bearer " + token,
						},
					})
						.then((response) => {
							if (response.data.available) {
								this.userUrl = response.data.url;
								this.urlChecked = true;
								if (this.validateInputs()) {
									this.$store.dispatch("WIZARD_BLOCK_NEXT", [
										false,
									]);
								}
							} else {
								this.urlChecked = false;
								this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
							}
							this.API_CALL_IN_PROGRESS = false;
						})
						.catch((response) => {
							console.log(response);
							this.API_CALL_IN_PROGRESS = false;
						});
				}
			},
			validateInputs() {
				if (this.artisticName.length > 3 && this.userUrl.length >= 2) {
					return true;
				} else {
					return false;
				}
			},
			submitWizard(){
				this.API_CALL_IN_PROGRESS = true;
				const token = this.$session.get("jwt");
				const siteId = this.$session.get("siteId");
				axios({
					method: "post",
					url: `${process.env.ROOT_API}/api/site/${siteId}/wizard/commit`,
					data: {
						wizard: this.$store.state.wizard.dataSite,
						components: this.$store.state.wizard.components,
					},
					headers: {
						Authorization: "Bearer " + token,
					},
				})
					.then(() => {
						this.API_CALL_IN_PROGRESS = false;
					})
					.catch((response) => {
						console.log(response);
						this.API_CALL_IN_PROGRESS = false;
					});
			},
			toggleContent(){
				this.showRealContent = !this.showRealContent;
			}
		},
		computed: {
			urlComplement() {
				let url = window.location.hostname;
				url = url.replace("painel", "");
				return `${url}`;
			},
		},
		watch: {
			artisticName() {
				if (this.artisticName.length < 3) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
				}
				this.$store.dispatch("UPDATE_COMMERCIAL_NAME", [
					this.artisticName,
					this.userUrl,
					this.listCities,
				]);
			},
		},
		destroyed() {
			this.$store.dispatch("UPDATE_COMMERCIAL_NAME", [
				this.artisticName,
				this.userUrl,
				this.listCities,
			]);
		},
	};
</script>

<style>
	.trava--wizard{
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		color: #fff;
		background-color: var(--bg-color);
		z-index: 3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: stretch;
	}
	.link--button:hover{
		text-decoration: none;
	}
	.insta--button{
		display: flex;
		flex-direction: row;
		align-content: center;
		justify-content: space-around;
		align-items: center;
		margin: 0 auto;
		background: linear-gradient(90deg, rgba(151,62,191,1) 0%, rgba(215,58,118,1) 25%, rgba(241,126,58,1) 75%, rgba(251,217,116,1) 100%);
		color: #fff;
		padding: 5px 20px;
		border: 2px solid rgba(151,62,191,1)
	}
	.insta--button i{
		font-size: 2rem;
		margin-right: 10px;
	}
	.insta--button:hover{
		color: #fff;
	}
	.add--list--button {
		color: #fff;
		background-color: var(--main-color);
		width: 32px;
		height: 32px;
		display: inline-block;
		margin: 10px 10px 0 0;
		border-radius: 50%;
	}
	.add--list--button::after {
		content: "+";
		font-weight: 700;
		font-size: 21px;
		position: relative;
		left: calc(50% - 6px);
	}
	.span--cities {
		background-color: #f8f8f8;
		color: #9a9a9a;
		height: 32px;
		padding: 2px 24px;
		border-radius: 20px;
		display: inline-block;
		cursor: pointer;
		margin: 10px 10px 0 0;
	}
	.show--content--button{
		position: fixed;
		right: 0;
		top: 0;
		z-index: 5;
		opacity: 0;
		color: #fff;
		background-color: #fff;
		border: none;
	}
	.show--content--button:hover{
		opacity: 1;
		background-color: #fff;
		color: #ccc;
	}
	.btn-schedule {
		background-color: var(--white);
	}
	.btn-schedule i {
		color: var(--main-color);
	}
	/* @media all and (max-width: 600px){
		.show--content--button{
			display: none;
		}
	} */
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardCommercialName.vue